import { get } from 'lodash';

/* eslint-disable @typescript-eslint/no-explicit-any */
export class FlattenUtils {
  static flattenDeep = (element: any, key: string, predicate: (params: any) => boolean = () => true): any[] => {
    let flatArray: any[] = [];
    const flattenData = (data: unknown) => {
      if (predicate(data)) {
        flatArray.push(data);
        if (get(data, key)) {
          flatArray = flatArray.concat(this.flattenDeep(get(data, key), key, predicate));
        }
      }
    };
    if (Array.isArray(element)) {
      element.forEach((item) => {
        flattenData(item);
      });
    } else {
      flattenData(element);
    }
    return flatArray;
  };

  static flattenObjectDeep = (obj, roots = [], sep = '.') =>
    Object
      // find props of given object
      .keys(obj)
      // return an object by iterating props
      .reduce(
        (memo, prop) =>
          Object.assign(
            // create a new object
            {},
            // include previously returned object
            memo,
            Object.prototype.toString.call(obj[prop]) === '[object Object]'
              ? // keep working if value is an object
                this.flattenObjectDeep(obj[prop], roots.concat([prop]), sep)
              : // include current prop and value and prefix prop with the roots
                { [roots.concat([prop]).join(sep)]: obj[prop] }
          ),
        {}
      );

  static flattenObjectDeepSplit(source: Record<string, any>, prefix: string = '', result: Record<string, any> = {}): Record<string, any> {
    // For each nested key, build the path and store the object or value
    if (prefix) {
      result[prefix] = source;
    }
    if (typeof source === 'object' && source !== null && !Array.isArray(source)) {
      for (const key of Object.keys(source)) {
        const newKey = prefix ? prefix + '.' + key : key;
        this.flattenObjectDeepSplit(source[key], newKey, result);
      }
    }
    return result;
  }
}
